<template>
  <div>
    ITEMS PAGE
  </div>
</template>

<script>
export default {
  name: 'GOOD3',
  data: () => ({
  }),
  props: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
